import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const BulbIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 407.656 407.656" width={props.height} height={props.height} >
		<g>
			<path d="M307.683,228.803l6.137-9.868c6.495-10.047,28.076-46.195,28.076-80.847
		C341.896,61.964,279.94,0,203.816,0C127.684,0,65.76,61.964,65.76,138.088c0,34.62,21.598,70.767,28.222,81.083
		c-0.171-0.236,9.787,15.558,9.787,15.558c17.379,27.223,33.758,52.974,37.627,84.407c0.829,6.714,6.511,11.754,13.258,11.754
		h100.429c6.722,0,12.429-5.04,13.266-11.721C272.519,285.28,289.605,257.822,307.683,228.803z"/>
			<path d="M256.887,346.009H149.72c-5.056,0-9.153,4.113-9.153,9.169c0,5.064,4.097,9.145,9.153,9.145h107.167
		c5.04,0,9.145-4.081,9.145-9.145C266.032,350.13,261.927,346.009,256.887,346.009z"/>
			<path d="M256.887,378.263H149.72c-5.056,0-9.153,4.121-9.153,9.169c0,5.064,4.097,9.145,9.153,9.145h22.175
		c0.91,6.259,6.194,11.079,12.705,11.079h38.424c6.519,0,11.819-4.82,12.713-11.079h21.151c5.04,0,9.145-4.081,9.145-9.145
		C266.032,382.384,261.927,378.263,256.887,378.263z"/>

		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Bulb.tsx